import { render, staticRenderFns } from "./dealWith.vue?vue&type=template&id=0b912ea1&scoped=true&"
import script from "./dealWith.vue?vue&type=script&lang=js&"
export * from "./dealWith.vue?vue&type=script&lang=js&"
import style0 from "./dealWith.vue?vue&type=style&index=0&id=0b912ea1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b912ea1",
  null
  
)

export default component.exports